import React                from "react";
import PropTypes            from "prop-types";
import Store                from "Dashboard/Core/Store";
import useForm              from "Dashboard/Hooks/Form";
import useDialog            from "Dashboard/Hooks/Dialog";

// Components
import MediaField           from "Components/Utils/Inputs/MediaField";

// Dashboard
import EditDialog           from "Dashboard/Components/Dialogs/EditDialog";
import InputField           from "Dashboard/Components/Form/InputField";



/**
 * The Title Edit Dialog
 * @param {Object} props
 * @returns {React.ReactElement}
 */
function TitleEdit(props) {
    const { open, elemCode, onClose, onSubmit } = props;

    const { editElem } = Store.useAction("title");


    // The Initial Data
    const initialData = {
        titleCode : "",
        name      : "",
        image     : "",
    };

    // The Form State
    const {
        data, errors, setElem, handleChange, handleSubmit,
    } = useForm("title", initialData, editElem, onSubmit);

    // Load the Data
    const { loading } = useDialog("title", open, elemCode, {}, setElem);


    // Do the Render
    return <EditDialog
        open={open}
        icon="title"
        title="TITLES_EDIT_TITLE"
        error={errors.form}
        onSubmit={handleSubmit}
        onClose={onClose}
        isLoading={loading}
        isNarrow
    >
        <InputField
            name="name"
            label="GENERAL_NAME"
            value={data.name}
            error={errors.name}
            onChange={handleChange}
            isRequired
        />
        <MediaField
            name="image"
            label="GENERAL_IMAGE"
            helperText="TITLES_IMAGE_TIP"
            value={data.image}
            error={errors.image}
            onChange={handleChange}
            onlyImages
            isRequired
        />
    </EditDialog>;
}

/**
 * The Property Types
 * @typedef {Object} propTypes
 */
TitleEdit.propTypes = {
    open     : PropTypes.bool.isRequired,
    onClose  : PropTypes.func.isRequired,
    onSubmit : PropTypes.func.isRequired,
    elemCode : PropTypes.string,
};

export default TitleEdit;
